import logo from './logo.svg';
import './App.css';
import Home from './pages/Home';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router";
import Development from './pages/Development';
import Creative from './pages/Creative';
import Objects from './pages/Objects';
import About from './pages/About';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home></Home>,
  },
  {
    path: "/development",
    element: <Development></Development>,
  },
  {
    path: "/creative",
    element: <Creative></Creative>,
  },
  {
    path: "/objects",
    element: <Objects></Objects>,
  },
  {
    path: "/about",
    element: <About></About>,
  },
]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
